import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { AuthProvider } from '@herond/shared/auth/AuthProvider';
import { RequireRole } from '@herond/shared/auth/RequireRole';
import { UserRole } from '@herond/shared/types/user';

import Loadable from '@components/Loadable';
import { ROUTE_PATH } from '@constants/route-path';

import DashboardPage from './pages/Dashboard/DashboardPage';

const Point = Loadable(lazy(async () => await import('@point/Module')));
const User = Loadable(lazy(async () => await import('@user/Module')));
const Id = Loadable(lazy(async () => await import('@id/Module')));
const Browser = Loadable(lazy(async () => await import('@browser/Module')));

const Login = Loadable(lazy(async () => await import('./pages/Login')));
const NotFound = Loadable(lazy(async () => await import('@herond/shared/components/NotFound')));
const Home = Loadable(lazy(async () => await import('./pages/Home')));

const hostUIRoutes: RouteObject[] = [
  { path: ROUTE_PATH.LOGIN, element: <Login /> },
  {
    path: ROUTE_PATH.HOME,
    element: (
      <AuthProvider>
        <Home />
      </AuthProvider>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      {
        path: `${ROUTE_PATH.POINT}/*`,
        element: (
          <RequireRole allowedRoles={[UserRole.Admin, UserRole.Operator]}>
            <Point />
          </RequireRole>
        ),
      },
      {
        path: `${ROUTE_PATH.USER}/*`,
        element: (
          <RequireRole allowedRoles={[UserRole.Admin]}>
            <User />
          </RequireRole>
        ),
      },
      {
        path: `${ROUTE_PATH.ID}/*`,
        element: (
          <RequireRole allowedRoles={[UserRole.Admin]}>
            <Id />
          </RequireRole>
        ),
      },
      {
        path: `${ROUTE_PATH.BROWSER}/*`,
        element: (
          <RequireRole allowedRoles={[UserRole.Admin, UserRole.Operator]}>
            <Browser />
          </RequireRole>
        ),
      },
    ],
  },
  { path: ROUTE_PATH.ALL, element: <NotFound /> },
];

export default hostUIRoutes;
